import { defineStore } from 'pinia';
import authService from '@/services/auth.service';
import { Auth } from '@/services/endpoint/auth-api.service';

export const useAuthStore = defineStore('auth', {
  state: () => ({
    loggedIn: false,
    user: null
  }),
  actions: {
    async login(credentials) {
      const res = await authService.login(credentials);
      delete res.token;
      this.loggedIn = true;
      this.user = res;
      return res;
    },
    /**
     * เติมฟิลด์ที่ store เก่ายังไม่มีจาก /profile (store นี้ persist ข้ามการ deploy)
     *
     * เคสจริง: คนที่ล็อกอินค้างไว้ก่อนอัปเดตจะไม่มี is_owner ใน store → ปุ่มที่ผูกกับสิทธิ์เจ้าของ
     * จะไม่ขึ้นจนกว่าจะ logout/login ใหม่ (api/docs/password-reset.md)
     */
    async ensureUserField(field) {
      if (!this.user || this.user[field] !== undefined) return this.user;
      try {
        const res = await Auth.getProfile();
        this.user = { ...this.user, ...res.data.data };
      } catch (e) {
      }
      return this.user;
    },
    logout() {
      this.loggedIn = false;
      this.user = null;
    }
  },
  persist: true
});
